/**
 * Partner-felvitel belépő-kérdése: MIT INTÉZ az ügyfél? (61Y / partner-L1, 3. réteg)
 *
 * A pultos ezt választja ki először, és a felvitel onnantól csak azt kéri, ami az
 * adott ügyhöz kell — a szabályt a [[partner-field-matrix]] hordozza, ez a komponens
 * csak a választást adja.
 *
 * ⚠️ A választás SZÁNDÉKOSAN elhagyható: intent nélkül a form a korábbi viselkedését
 * tartja (nincs extra jelölés, nincs elrejtés). Így a pultos nem kényszerül döntésre
 * olyan felvitelnél, ahol még nem tudja, mit fog intézni az ügyfél.
 */

import { useTranslation } from '@kgc/i18n';
import type { TransactionIntent } from '../partner-field-matrix';

interface TransactionIntentCardsProps {
  value: TransactionIntent | null;
  onChange: (intent: TransactionIntent | null) => void;
}

const INTENTS: ReadonlyArray<{ value: TransactionIntent; labelKey: string; testId: string }> = [
  { value: 'PURCHASE', labelKey: 'partner.intent.purchase', testId: 'partner-intent-purchase' },
  { value: 'RENTAL', labelKey: 'partner.intent.rental', testId: 'partner-intent-rental' },
  { value: 'SERVICE', labelKey: 'partner.intent.service', testId: 'partner-intent-service' },
];

export function TransactionIntentCards({ value, onChange }: TransactionIntentCardsProps) {
  const { t } = useTranslation();

  return (
    <div data-testid="partner-intent-cards">
      <p className="mb-3 text-sm text-muted-foreground">{t('partner.intent.hint')}</p>
      <div className="grid gap-3 sm:grid-cols-3">
        {INTENTS.map(intent => {
          const selected = value === intent.value;
          return (
            <button
              key={intent.value}
              type="button"
              aria-pressed={selected}
              onClick={() => onChange(selected ? null : intent.value)}
              data-testid={intent.testId}
              className={`rounded-md border px-4 py-3 text-sm font-medium transition-colors ${
                selected
                  ? 'border-primary bg-primary/10 text-primary'
                  : 'border-input bg-background hover:bg-accent hover:text-accent-foreground'
              }`}
            >
              {t(intent.labelKey)}
            </button>
          );
        })}
      </div>
    </div>
  );
}
